import Reservation from '@/services/hatsApi/Reservation'
import Transport from '@/services/hatsApi/Transport'
import moment from 'moment'
export const rlProps = {
  props: {
    item: {
      type: Object,
      required: true
    },
    rollingStocks: {
      default: () => ([]),
      type: Array,
      required: false
    },
    travelers: {
      default: () => ([]),
      type: Array,
      required: false
    },
    prices: { // priceCalc api response
      type: Object,
      required: true
    },
    reservationId: {
      type: String | Number,
      required: false
    },
    selectedClass: {
      type: String | Number,
      required: false
    },
    selectedRoomType: {
      type: String,
      required: false
    },
    selectedRoomsAmount: {
      type: String | Number,
      required: false
    },
    dataIsFilling: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      service: this.item,
      stockItems: this.rollingStocks,
      selectedStock: this.item.rollingStockId || this.rollingStocks[0], // Dropdown if there are multiple stocks
      times: [],
      placements: [],
      customPrices: [],
      passengers: this.travelers,
      updateServiceLineRan: false,
      stockCounter: 0,
      timeCounter: 0,
      subtotalCounter: 0,
      travelersKey: 0,
      prompt: '',
      countries: this.$store.getters.countries
    }
  },
  computed: {
    serviceTypeName () {
      return this.service.service.serviceType.code.charAt(0).toUpperCase() + this.service.service.serviceType.code.slice(1).toLowerCase()
    },
    isOutbound () {
      let rollingStock = this.$_.find(this.rollingStocks, {'id': this.getSelectedRollingStockId() + ''})
      if (!rollingStock) {
        return null
      }
      return !+rollingStock.returnJourney
    },
    getTransportTypePrices () {
      // init does not have any price calculations yet
      if (!this.prices || !this.prices.hasOwnProperty('reservationLines') || !this.prices.reservationLines.length) {
        return []
      }
      let transportTypePrices = this.prices.reservationLines[this.service.index]
      // if (transportTypePrices && !transportTypePrices.error) {
      if (this.item.supplierType === 'Free sale' || !this.item.stock) {
        return transportTypePrices
      } else {
        return transportTypePrices.rollingStockCoupes
      }
      // } else {
      //   return []
      // }
    },
    getDefaultTypePrices () {
      // init does not have any price calculations yet
      if (!this.prices || !this.prices.hasOwnProperty('reservationLines')) {
        return []
      }
      let typePrices = this.prices.reservationLines[this.service.index]
      if (typePrices && typePrices.reservationLines && typePrices.reservationLines.length) {
        return typePrices.reservationLines
      } else {
        return []
      }
    },
    getSubTotal () {
      let field = this.item.extra ? 'extraReservationLines' : 'reservationLines'
      if (!this.prices || !this.prices.hasOwnProperty(field)) {
        return 0
      }
      let reservationLinePrice = this.prices[field][this.item.index]
      if (reservationLinePrice) {
        // A transport
        if (reservationLinePrice.hasOwnProperty('rollingStockCoupes')) {
          return reservationLinePrice.subTotalSalePrice
        } else {
          // Not a transport
          if (reservationLinePrice.hasOwnProperty('reservationLines') && reservationLinePrice.reservationLines.length) {
            return this.$_.sumBy(reservationLinePrice.reservationLines, (rPrice) => {
              return rPrice.subTotalSalePrice
            })
          } else {
            return 0
          }
        }
      } else {
        return 0
      }
    },
    actionDateCalculated () {
      if (this.item.service.daysBeforeBooking && this.item.dateFrom) {
        return moment(this.item.dateFrom)
          .subtract(this.item.service.daysBeforeBooking, 'days')
          .format('DD-MM-YYYY')
      }
      return ''
    },
    formattedActionDate () {
      if (this.item.actionDate) {
        return moment(this.item.actionDate)
          .format('DD-MM-YYYY')
      }
      return ''
    }
  },
  created () {
    if (this.item.rollingStockCoupes.length) {
      this.item.rollingStockCoupes.forEach((rollingStockCoupe) => {
        this.placements.push({
          amount: rollingStockCoupe.amount,
          id: rollingStockCoupe.serviceId
        })
      })
    }
    if (this.rollingStocks.length) {
      this.loadTimes()
    } else {
      this.loadFreeSaleTimes()
    }
    this.preparePrompt()
  },
  methods: {
    setOccupancyLoaded (item) {
      this.$emit('occupancyLoaded', true)
    },
    clearActionDate (item) {
      item.actionDate = ''
    },
    activateActionDate (item) {
      item.actionDate = moment(this.actionDateCalculated, 'DD-MM-YYYY').format('YYYY-MM-DD')
    },
    customRoomsAmountChanged (reservationId, bedsRoomNeeded) {
      this.$emit('customRoomsAmountChanged', reservationId, bedsRoomNeeded)
    },
    reloadTravelersKey () {
      this.travelersKey += 1
    },
    getSelectedRollingStockId () {
      let id = null
      if (this.selectedStock) {
        if (isNaN(this.selectedStock)) {
          id = this.selectedStock.id
        } else {
          id = this.selectedStock
        }
      }
      // Check if we need a different id, because the date has been changed
      if (this.rollingStocks.length) {
        let found = this.$_.find(this.rollingStocks, {'id': id + ''})
        if (!found) {
          id = this.rollingStocks[0].id
        }
      } else {
        return null
      }
      return parseInt(id)
    },
    // For edit mode only, so we can retrieve the booked seats from the api
    getReservationLineId () {
      if (!this.service.new) {
        return this.service.id
      } else {
        return 0
      }
    },
    updateFreeSaleType (freeSaleTypes, cloneItem) {
      let selectedFreeSaleTypes = []
      freeSaleTypes.forEach((freeSaleType) => {
        if (parseInt(freeSaleType.amount) > 0) {
          selectedFreeSaleTypes.push(freeSaleType)
        }
      })
      // this.placements = selectedFreeSaleTypes
      this.customPrices = selectedFreeSaleTypes
      // Update service line will call price calculation
      this.updateServiceLine(cloneItem)
    },
    // set available transport types for the travelers to select
    updateTravelersTransportType (transportTypes) {
      let selectedTransportTypes = []
      transportTypes.forEach((transportType) => {
        if (parseInt(transportType.amount) > 0) {
          selectedTransportTypes.push(transportType)
        }
      })
      this.placements = selectedTransportTypes
      this.reloadTravelersKey()
      // Update service line will call price calculation
      this.updateServiceLine()
    },
    setTravelerTransportType (val, traveler) {
      if (!parseInt(val)) {
        console.log('Not all travelers have a wagon')
        return
      }
      let placement = {
        serviceId: parseInt(this.service.serviceId),
        transportTypeId: parseInt(val),
        rollingStockCoupeId: null
      }
      let index = this.$_.findIndex(traveler.rollingStockCoupes, {'serviceId': parseInt(this.service.serviceId)})
      if (index !== -1) {
        traveler.rollingStockCoupes.splice(index, 1, placement)
      } else {
        traveler.rollingStockCoupes.splice(0, 1, placement)
      }
    },
    // set available room types for the travelers to select
    updateTravelersRoomType (roomTypes, currentItem) {
      let selectedRoomTypes = []
      roomTypes.forEach((roomType) => {
        // Removed if statement because used to cause problems with amount == 0
        // if (parseInt(roomType.amount) > 0) {
        selectedRoomTypes.push(roomType)
        // }
      })
      this.placements = selectedRoomTypes
      this.customPrices = selectedRoomTypes
      this.reloadTravelersKey()
      // Update service line will call price calculation
      this.updateServiceLine(currentItem)
    },
    async loadTimes () {
      try {
        let filters = [
          {
            property: 'rollingStockId',
            value: this.getSelectedRollingStockId()
          }
        ]
        const times = await Reservation.getTimes(filters)
        if (times.data.success) {
          if (times.data.data !== this.times) {
            this.times = times.data.data
            this.timeCounter += 1
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    async loadFreeSaleTimes () {
      try {
        let filters = [
          {
            property: 'serviceId',
            value: this.item.service.id
          },
          {
            property: 'date',
            value: this.item.dateFrom
          },
          {
            property: 'outbound',
            value: this.service.outbound || false
          }
        ]
        const periods = await Transport.getPeriods(filters)
        if (periods.data.success && periods.data.data.length) {
          try {
            let filters = [
              {
                property: 'transportTimePeriodId',
                value: periods.data.data[0].id
              }
            ]
            const times = await Transport.getTimes(filters)
            if (times.data.success) {
              if (times.data.data !== this.times) {
                this.times = times.data.data
                this.timeCounter += 1
              }
            }
          } catch (error) {
            console.error(error)
          }
        } else {
          this.times = []
          this.timeCounter += 1
        }
      } catch (error) {
        console.error(error)
      }
    },
    updateServiceLine (currentItem) {
      let reservationLine = {
        serviceId: this.service.serviceId,
        dateFrom: this.service.dateFrom,
        dateUntil: this.service.dateUntil,
        rollingStockId: this.getSelectedRollingStockId(),
        outbound: this.isOutbound,
        placements: this.placements,
        persons: this.passengers,
        customPrices: this.customPrices,
        totalSalePrice: this.getSubTotal
      }
      this.$emit('updateServiceLine', reservationLine, this.item.id, currentItem)
    },
    seatsChosen () {
      this.updateServiceLine()
    },
    roomsChosen () {
      this.updateServiceLine()
    },
    preparePrompt () {
      this.prompt = (this.item.service.prompt && this.item.service.prompt.text) ? (this.item.service.prompt.text + '\n\n') : ''
      if (this.prompt) {
        let dates = `${this.service.dateFrom} - ${this.service.dateUntil}`
        if (this.service.service.serviceType.code === 'TRANSPORT') {
          dates = this.service.dateFrom
        }
        this.prompt = `${this.service.service.title_NL} (${dates})\n\n${this.prompt}`
        let persons = []
        this.travelers.forEach(person => {
          let countryTitle = person.countryId.name_NL ? person.countryId.name_NL : (this.countries[person.countryId] ? this.countries[person.countryId].name_NL : '')
          persons.push(`${person.first_name} ${person.last_name}, ${countryTitle}, date of birth: ${person.birthdate}, passport: ${person.passportNumber}`)
        })
        if (this.prompt) {
          this.prompt += ('Travellers: \n' + persons.join(';\n'))
        }
      }
    }
  },
  watch: {
    selectedStock (val) {
      this.loadTimes()
      this.stockCounter += 1
    },
    'service.outbound' () {
      if (!this.rollingStocks.length) {
        this.loadFreeSaleTimes()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/reservationLineProperties.js